module.exports = __webpack_public_path__ + "static/media/composer-play-white.436473a4.svg";